import { create } from 'zustand';

export const useRawAttributesStore = create((set, get) => ({
  // État initial
  rawAttributes: [],

  // Actions
  setRawAttributes: (newRawAttributes) =>
    set({ rawAttributes: [...newRawAttributes] }),

  clearRawAttributes: () => set({ rawAttributes: [] }),

  getRawAttributes: () => get().rawAttributes,

  isRawAttributesLoaded: () => Array.isArray(get().rawAttributes),
}));
